import Vue from 'vue';
import { Route } from 'vue-router';
import router from '@/router';
import { APPLICATION_USER_DATA } from '@/queries/Application';

const permissionGuard = (
  permission: string,
  to: Route,
  from: Route,
  next: (to?: string | false | void | ((vm: Vue) => void)) => void,
) => {
  return new Promise((resolve, reject) => {
    router.app.$apollo.query({
      query: APPLICATION_USER_DATA,
    }).then(({ data }) => {
      if (data.currentUser.permissions[permission]) {
        next();
        resolve();
      } else {
        reject(router);
      }
    });
  });
};

export default permissionGuard;
